import React from 'react';
import SVG from 'react-inlinesvg';
import SearchBar from './SearchBar';
import SideBar from './SideBar';
import useStopScrolling from '../hooks/useStopScrolling';
import IconXBlack from '../../../../assets/images/reskin-images/icon--x-black.svg';

export default function RightSidebarPanel({ isOpen, onClose }) {
  useStopScrolling(isOpen);

  if (!isOpen) return null;

  return (
    <div style={{ zIndex: 10000 }} className="fixed pin-t pin-r pin-b pin-l">
      {/* Overlay Backdrop */}
      <div
        className="absolute pin-t pin-r pin-b pin-l"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
        onClick={onClose}
      />

      {/* Right Panel Content */}
      <div
        className="relative h-full bg-white shadow-2xl flex flex-col z-10 overflow-hidden"
        style={{
          width: '320px',
          maxWidth: '85vw',
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          backgroundColor: '#ffffff',
        }}
      >
        {/* Top Header: Search Bar & Close Button */}
        <div className="flex items-center justify-between p-4 gap-3 border-b border-gray">
          <div className="flex-grow min-w-0">
            <SearchBar onSearchSubmit={onClose} isMobileDrawer />
          </div>
          <button
            type="button"
            className="p-1 text-black hover:opacity-75 focus:outline-none flex-shrink-0 cursor-pointer"
            onClick={onClose}
          >
            <SVG src={IconXBlack} className="w-6 h-6" />
          </button>
        </div>

        {/* Sidebar Component */}
        <div className="flex-grow overflow-y-auto">
          <SideBar
            showLogo={false}
            className="flex flex-col w-full h-full"
            alwaysShowText
            onItemClick={onClose}
          />
        </div>
      </div>
    </div>
  );
}
